// extracted by mini-css-extract-plugin
module.exports = {"icon":"_0470f38","textWrapper":"_af26b31"};